import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

// Component imports
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import SolutionSection from '../components/SolutionSection';
import WhyItMatters from '../components/WhyItMatters';
import FoundersSection from '../components/FoundersSection';
import ProcessSection from '../components/ProcessSection';
import SocialProofSection from '../components/SocialProofSection';
import WhitepaperSection from '../components/WhitepaperSection';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    // SEO: Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": window.location.origin
        }
      ]
    };
    
    const scriptId = 'breadcrumb-structured-data';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(breadcrumbData);
    
  }, []);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-white"
      itemScope
      itemType="https://schema.org/WebPage"
    >
      <meta itemProp="name" content="Secure Enterprise AI Solutions Homepage" />
      <meta itemProp="description" content="Enterprise AI security solutions with private on-premise deployment" />
      
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <WhyItMatters />
      <FoundersSection />
      <ProcessSection />
      <SocialProofSection />
      <WhitepaperSection />
      <Footer />
    </motion.main>
  );
};

export default HomePage;